import React, { useRef } from 'react';
import { useKeepSizeAfterRender } from '../../hooks/stylingHooks';
// eslint-disable-next-line no-restricted-imports
import { Button } from '@material-ui/core';
import { Loader } from '../../components/common/Loader';
import { ButtonProps } from '../../components/common/Button';

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({ loading, children, ...props }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  useKeepSizeAfterRender(buttonRef, { keepWidth: true, keepHeight: true });

  return (
    <Button disabled={loading} ref={buttonRef} {...props}>
      {loading ? <Loader noMargin loaderSize={'3rem'} /> : children}
    </Button>
  );
};
